import { render, staticRenderFns } from "./chatFuncBtns.vue?vue&type=template&id=971ed27e&scoped=true"
import script from "./chatFuncBtns.vue?vue&type=script&lang=js"
export * from "./chatFuncBtns.vue?vue&type=script&lang=js"
import style0 from "./chatFuncBtns.vue?vue&type=style&index=0&id=971ed27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971ed27e",
  null
  
)

export default component.exports